/**
 * Weight.
 */
export class Weight {
  constructor(
    readonly value: number,
    readonly unit: WeightUnit,
  ) {}

  toString() {
    switch (this.unit) {
      case WeightUnit.GRAM:
        return `${this.value.toFixed(0)}g`;
      case WeightUnit.OUNCE:
        return `${Math.trunc(this.value / 16)}lb ${(this.value % 16).toFixed(2)}oz`;
    }
  }
}

/**
 * Weight unit.
 */
export enum WeightUnit {
  GRAM = "GRAM",
  OUNCE = "OUNCE",
}
